// extracted by mini-css-extract-plugin
export default {"product_list":"productlist_product_list__lZG57","example":"productlist_example__4XwmH"};